declare global {
  interface Window {
    __CONFIG__?: {
      apiUrl: string;
      userPoolId: string;
      userPoolClientId: string;
      region: string;
    };
  }
}

const fromWindow = typeof window !== 'undefined' ? window.__CONFIG__ : undefined;

export const config = {
  apiUrl: fromWindow?.apiUrl ?? import.meta.env.VITE_API_URL ?? 'http://localhost:3001',
  userPoolId: fromWindow?.userPoolId ?? import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: fromWindow?.userPoolClientId ?? import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  region: fromWindow?.region ?? import.meta.env.VITE_AWS_REGION ?? 'eu-west-1',
  localAuth: import.meta.env.VITE_LOCAL_AUTH === 'true',
  bookingUrl: 'https://cal.eu/beleidssignaal',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL ?? 'info@beleidssignaal.nl',
};
